import EfSpec from '@elem/ui/ef-spec';
import styles from './ProductContent.module.scss';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import D from './comps/D';
import E from './comps/E';
import EU1 from './comps/EU1';
import G from './comps/G';
import I from './comps/I';
import J from './comps/J';
import SecurityProtection from './comps/SecurityProtection';
import M from './comps/M';
import N from './comps/N';
import MX1 from './comps/MX1';
import MX2 from './comps/MX2';
import NA1 from './comps/NA1';
import NA4 from './comps/NA4';
import Q from './comps/Q';
import PageNavLeft from './comps/PageNavLeft';
import { useLang } from '@/i18n';

export default function Teaser() {
    const { t } = useLang('delta3series');



    return (
        <div className={`${styles.teaser} delta-3`}>
            <A />
            <B />
            <MX1 />
            <SecurityProtection />
            <div className="bg-black">
                <E />
                <MX2 />
                <C />
            </div>
            <NA4 />
            <D />
            <NA1 />
            <G />
            <J />
            <M />
            <I />
            <EU1 />
            <N />
            <EfSpec className="spec-x" />
            <Q />
            <PageNavLeft
                triggerElement=".delta-3"
                enterElement="#D3-B"
                steps={[
                    { text: t('page-nav-item1'), href: '#D3-B' },
                    { text: t('page-nav-item2'), href: '#D3-MX1' },
                    { text: t('page-nav-item3'), href: '#SecurityProtection' },
                    { text: t('page-nav-item4'), href: '#D3-E' },
                    { text: t('page-nav-item5'), href: '#D3-C' },
                    { text: t('page-nav-item6'), href: '#D3-G' },
                    { text: t('page-nav-item7'), href: '#D3-J' },
                    { text: t('page-nav-item8'), href: '#D3-M' },
                    { text: t('page-nav-item9'), href: '#D3-I' },
                ]}
            />


        </div>
    );
}
